import BackBanner from './BackBanner';

export default BackBanner;
